const features = [
  {
    icon: 'ri-flashlight-line',
    title: '实时更新',
    desc: '7×24小时不间断监控全网热点，确保黑料吃瓜内容第一时间推送到首页。',
  },
  {
    icon: 'ri-shield-check-line',
    title: '来源可靠',
    desc: '51黑料吃瓜网站所有内容均经过编辑团队核实筛选，为吃瓜群众提供可信的娱乐资讯。',
  },
  {
    icon: 'ri-smartphone-line',
    title: '多端适配',
    desc: '51吃瓜官网全网最新内容完美适配PC、平板和手机，随时随地畅享吃瓜体验。',
  },
  {
    icon: 'ri-links-line',
    title: '入口直达',
    desc: '提供51黑料入口最新地址，黑料吃瓜网址一键直达，无需繁琐跳转即可访问核心内容。',
  },
  {
    icon: 'ri-user-voice-line',
    title: '用户至上',
    desc: '保护爆料人隐私是51吃瓜网官网的基本原则，所有投稿严格保密，打造安全的吃瓜社区。',
  },
];

export default function FeaturesSection() {
  return (
    <section id="features" className="py-12 md:py-16 bg-background-100">
      <div className="w-full max-w-5xl mx-auto px-4 md:px-6">
        <div className="text-center mb-10">
          <h2 className="text-xl md:text-2xl font-bold text-foreground-950 font-heading">
            平台特色
          </h2>
          <p className="mt-2 text-sm text-foreground-500">为什么选择51黑料吃瓜网</p>
        </div>
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-5 gap-4">
          {features.map((feature, i) => (
            <div
              key={i}
              className="bg-background-50 rounded-xl border border-background-200/60 p-5 text-center hover:border-primary-200 transition-all duration-300 cursor-pointer group"
            >
              <div className="w-12 h-12 mx-auto rounded-xl bg-accent-100 flex items-center justify-center group-hover:bg-accent-200 transition-colors">
                <i className={`${feature.icon} text-xl text-accent-600`}></i>
              </div>
              <h3 className="mt-3 text-sm font-semibold text-foreground-800">{feature.title}</h3>
              <p className="mt-2 text-xs text-foreground-500 leading-relaxed">{feature.desc}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}